import React from "react";
import ContractualPartnerData from "../../ContractLaw/Summary/ContractualPartnerData";
import Grid from "@mui/material/Grid";
import summaryStyle from "../../Common/Style/summaryStyle";
import { Box } from "@mui/material";
import { translate } from "../../../../services/translations/translations";

type LandLordDataProps = {
  formData: Record<string, any>;
};

export const OpposingPartyData = ({ formData }: LandLordDataProps) => {
  const opposingPartyLabel =
    formData.contractPartyType === "tenant"
      ? translate("rentalContract.contractPartyType.options.landlord.label", formData)
      : translate("rentalContract.contractPartyType.options.tenant.label", formData);

  return (
    <>
      <ContractualPartnerData formData={formData} title={"Angaben zum " + opposingPartyLabel} />
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"name"} sx={summaryStyle.scrollToAnchor} />
        Hausverwaltung vorhanden
      </Grid>
      <Grid size={12}>
        {formData.hasPropertyManager === "yes" ? "Ja" : "Nein"}
      </Grid>
      {formData.hasPropertyManager === "yes" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"name"} sx={summaryStyle.scrollToAnchor} />
            Name Hausverwaltung
          </Grid>
          <Grid size={12}>
            {formData.propertyManager.organization.legalName}
          </Grid>
          {formData.propertyManager.organization.address.streetAddress && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"streetAddress"} sx={summaryStyle.scrollToAnchor} />
                Straße und Hausnummer Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.address.streetAddress}
              </Grid>
            </>
          )}
          {formData.propertyManager.organization.address.postalCode && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"postalCode"} sx={summaryStyle.scrollToAnchor} />
                PLZ Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.address.postalCode}
              </Grid>
            </>
          )}
          {formData.propertyManager.organization.address.addressLocality && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"addressLocality"} sx={summaryStyle.scrollToAnchor} />
                Ort Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.address.addressLocality}
              </Grid>
            </>
          )}
          {formData.propertyManager.organization.mainEmail.email && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"email"} sx={summaryStyle.scrollToAnchor} />
                E-Mail Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.mainEmail.email}
              </Grid>
            </>
          )}
          {formData.propertyManager.organization.telephone && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"telephone"} sx={summaryStyle.scrollToAnchor} />
                Telefonnummer Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.telephone}
              </Grid>
            </>
          )}
          {formData.propertyManager.organization.fax && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"telephone"} sx={summaryStyle.scrollToAnchor} />
                Faxnummer Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.fax}
              </Grid>
            </>
          )}
          {formData.propertyManagerReference && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"telephone"} sx={summaryStyle.scrollToAnchor} />
                Aktenzeichen Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManagerReference}
              </Grid>
            </>
          )}
        </>
      )}
    </>
  );
};
